import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterLink } from '@angular/router';
import { CanDirective, CapabilitiesService, CapabilityNames, DynamicRouteService, HeaderService } from 'core';
import { finalize } from 'rxjs';
import { ReceiptType } from '../../interfaces/receipt.model';
import { ReceiptsService } from '../../services/receipts.service';
import { toRouteSegments } from '../../utils/receipt.utils';
import { RECEIPTS_DESCRIBE } from '../constants';
import { receipts_MOCK } from '../mocks/receipts.mock';

@Component({
  selector: 'app-receipts',
  imports: [CanDirective, MatButtonModule, RouterLink],
  templateUrl: './receipts.html',
  styleUrl: './receipts.scss',
})
export class Receipts implements OnInit, OnDestroy {
  readonly CAPS = CapabilityNames;

  readonly userMock = receipts_MOCK.home.utente;

  isLoading = false;

  newReceiptLink: string[] = [];
  inProgressLink: string[] = [];
  worksheetsLink: string[] = [];
  depositsLink: string[] = [];

  private counts: Record<string, number> | null = null;

  private readonly headerService = inject(HeaderService);
  readonly capabilities = inject(CapabilitiesService);
  private readonly service = inject(ReceiptsService);
  private readonly router = inject(Router);
  private readonly dynamicRouteService = inject(DynamicRouteService);

  ngOnInit(): void {
    this.headerService.removeActions();
    this.headerService.setTitle('Incassi');

    this.newReceiptLink = this.linkFor('select-customer');
    this.inProgressLink = this.linkFor('receipts-in-progress');
    this.worksheetsLink = this.linkFor('receipts-brogliacci');
    this.depositsLink = this.linkFor('receipts-distinte');

    this.loadSummary();
  }

  ngOnDestroy(): void {
    this.headerService.removeTitle();
    this.headerService.removeActions();
  }

  get incassiCount(): string {
    return this.readCount(ReceiptType.Receipt);
  }

  get brogliacciCount(): string {
    return this.readCount(ReceiptType.Worksheet);
  }

  get distinteCount(): string {
    return this.readCount(ReceiptType.Deposit);
  }

  loadSummary(): void {
    this.isLoading = true;

    this.service
      .getSummary()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: summary => {
          this.counts = {};

          for (const entry of summary?.receipts ?? []) {
            this.counts[entry.receiptType] = entry.count;
          }
        },
        error: err => {
          console.error('Errore caricamento riepilogo incassi', err);
          this.counts = null;
        },
      });
  }

  private linkFor(routeId: string): string[] {
    const path = this.dynamicRouteService.getRoutePath(this.router, RECEIPTS_DESCRIBE, routeId);

    if (!path) {
      console.error(`Rotta ${routeId} non configurata`);
      return [];
    }

    return ['/', ...toRouteSegments(path)];
  }

  private readCount(type: ReceiptType): string {
    return this.counts ? String(this.counts[type] ?? 0) : '-';
  }
}
